import { HYDRATE } from 'next-redux-wrapper';

import { UserSavedSearch } from '../../types/userSavedSearch.types';
import { USER_SAVED_SEARCHES_SET } from '../action-types/user-saved-searches.action-types';

export type UserSavedSearchReducer = {
  userSavedSearches: UserSavedSearch[];
};

const initialState: UserSavedSearchReducer = {
  userSavedSearches: [],
};

const userSavedSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case HYDRATE: {
      return { ...state, ...action.payload.userSavedSearches };
    }
    case USER_SAVED_SEARCHES_SET: {
      return {
        ...state,
        userSavedSearches: action.data,
      };
    }
    default: {
      return state;
    }
  }
};

export default userSavedSearchReducer;
